// ✅ Use official Firebase SDK, not @firebase/*
import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';
import { fcmCredentials } from './mixins/Credentials';

const firebaseConfig = {
  apiKey: fcmCredentials.apiKey,
  authDomain: fcmCredentials.authDomain,
  databaseURL: fcmCredentials.databaseURL,
  projectId: fcmCredentials.projectId,
  storageBucket: fcmCredentials.storageBucket,
  messagingSenderId: fcmCredentials.messagingSenderId,
  appId: fcmCredentials.appId,
  measurementId: fcmCredentials.measurementId,
};

const app = initializeApp(firebaseConfig);

// Conditional messaging init (based on browser support)
const messaging = isSupported().then((supported) => {
  if (supported) {
    return getMessaging(app);
  } else {
    console.warn('Firebase messaging is not supported in this browser.');
    return null;
  }
});

export { messaging };
